import type { WeatherSnapshot } from './weather-adapter';

export function weatherSymbol(weather: Pick<WeatherSnapshot, 'weatherCode' | 'isDay'> | null) {
  const code = weather?.weatherCode;
  if (code === 0 || code === 1) return weather?.isDay === false ? 'moon' : 'sun';
  if (code === 2) return weather?.isDay === false ? 'cloud-moon' : 'cloud-sun';
  if (code === 3) return 'cloud';
  if (code === 45 || code === 48) return 'fog';
  if (code === 51 || code === 53 || code === 55) return 'drizzle';
  if ([56, 57, 61, 63, 65, 66, 67, 80, 81, 82].includes(code ?? -1)) return 'rain';
  if ([71, 73, 75, 77, 85, 86].includes(code ?? -1)) return 'snow';
  if (code === 95) return 'thunder';
  if (code === 96 || code === 99) return 'hail';
  return 'unknown';
}
